import { CardStyle } from "./style";

export const CardComponent = props => (
    <CardStyle>
        {props.children}
    </CardStyle>
)